import { React, useState, useEffect, useRef } from 'react';
import { Modal, Form, Input, DatePicker, Image } from 'antd';
import locale from 'antd/es/date-picker/locale/es_ES';
import moment from 'moment';
import NewUserFields from '../adminSects/users/fields/NewUserFields';
import NewPharmacyFields from '../adminSects/users/fields/NewPharmacyFields';
import EditUserFields from '../adminSects/users/fields/EditUserFields';
import EditNoPhUserFields from '../adminSects/users/fields/EditNoPhUserFields';
import EditUserFieldsNoPs from '../adminSects/users/fields/EditUserFieldsNoPs';
import EditNoPhUserFieldsNoPs from '../adminSects/users/fields/EditNoPhUserFieldsNoPs';
import UserDataFields from '../adminSects/users/fields/UserDataFields';
import NoPhUserDataFields from '../adminSects/users/fields/NoPhUserDataFields';
import { FormBuilder, CustomButton, message } from './Utils';
import style from './modals.module.scss';
import axios from './../../config/apiConfig';
import {
  CloseOutlined,
  PlusOutlined,
  MinusOutlined,
  UploadOutlined,
  LoadingOutlined,
  FormOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined 
} from '@ant-design/icons';
import DisplayStands from './DisplayStands';
import standFull from './../../img/Stand_Full.png';
import standMedium from './../../img/Stand_Medium.png';
import standSmall from './../../img/Stand_Small.png';

// /admin New User Modal
const ModalAddUser = (props) => {
  const { showAddUserModal, setShowAddUserModal, toggleModal, newUser } = props;
  const [fields, setFields] = useState([]);
  const [userRole, setUserRole] = useState('');

  const [form] = Form.useForm();

  useEffect(() => {
    if (userRole === 'pharmacy') {
      const fields = NewPharmacyFields();
      setFields(fields);
    } else {
      const fields = NewUserFields();
      setFields(fields);
    }
  }, [userRole]);

  const generateRandomPS = () => {
    let chart =
      '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
    let passLength = 6;
    let pass = '';
    for (let i = 1; i <= passLength; i++) {
      let digit = Math.floor(Math.random() * chart.length);
      pass = pass + chart[digit];
    }
    return pass;
  };

  const onFinish = async (values) => {
    try {
      if (userRole === 'pharmacy') {
        const user = {
          userPassword: generateRandomPS(),
          role: 'pharmacy',
          accountNumber: values?.accountNumber,
          pharmacy: {
            email: values.email,
            owner: values.owner,
            name: values.name,
            cellPhone: values.cellPhone,
            nameResponsible: values.nameResponsible,
            responsibleCellPhone: values.responsibleCellPhone,
          },
        };
        newUser(user, form);
      } else {
        delete values.pharmacy;
        const user = {
          userPassword: generateRandomPS(),
          role: userRole === 'admin' ? 'admin' : 'supplier',
          fullName: values.fullName,
        };
        if (values.emailOrAcc.indexOf('@') === -1) {
          user.accountNumber = values.emailOrAcc;
        } else {
          user.email = values.emailOrAcc;
        }
        newUser(user, form);
      }
      toggleModal(setShowAddUserModal, showAddUserModal);
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  };

  const onFieldsChange = (value) => {
    if (value[0].name[0] === 'role') {
      setUserRole(value[0].value);
    }
  };

  return (
    <Modal
      title="Agregar usuario"
      visible={showAddUserModal}
      footer={null}
      onCancel={() => toggleModal(setShowAddUserModal, showAddUserModal)}
      className={style.newUserModal}
    >
      <div>
        <Form
          form={form}
          layout="vertical"
          labelCol={{
            span: 15,
          }}
          name="basic"
          onFinish={onFinish}
          onFieldsChange={onFieldsChange}
          style={{ 'margin-top': '.25rem' }}
        >
          <FormBuilder items={fields} />
          <Form.Item>
            <div>
              <CustomButton
                color="btnOutline"
                size="bg"
                htmlType="submit"
                content="AGREGAR"
                className={style.addUserFooterBtn}
              />
            </div>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

// /admin Edit User Modal
const ModalEditUser = (props) => {
  const {
    showEditUser,
    setShowEditUser,
    toggleModal,
    userTriggerData,
    setEditedDataUser,
    setErrorModalMsg,
  } = props;
  const [fields, setFields] = useState([]);
  const [form] = Form.useForm();
  const [changePassword, setChangePassword] = useState(false);

  const handleCheckBox = (e) => {
    setChangePassword(e.target.checked);
  };

  useEffect(() => {
    setChangePassword(false);
    form.resetFields();
  }, [showEditUser]);

  useEffect(() => {
    if (userTriggerData?.role === 'pharmacy') {
      if (changePassword) {
        const fields = EditUserFields(userTriggerData, handleCheckBox);
        setFields(fields);
      } else {
        const fields = EditUserFieldsNoPs(userTriggerData, handleCheckBox);
        setFields(fields);
      }
    } else if (
      userTriggerData?.role === 'supplier' ||
      userTriggerData?.role === 'admin'
    ) {
      if (changePassword) {
        const fields = EditNoPhUserFields(userTriggerData, handleCheckBox);
        setFields(fields);
      } else {
        const fields = EditNoPhUserFieldsNoPs(userTriggerData, handleCheckBox);
        setFields(fields);
      }
    }
  }, [userTriggerData, changePassword]);

  const onFinish = async (values) => {
    try {
      delete values.passRepeat;
      if (userTriggerData.role === 'pharmacy') {
        const user = {
          userPassword: values.userPassword,
          pharmacy: {
            email: values.email,
            owner: values.owner,
            name: values.name,
            cellPhone: values.cellPhone,
            nameResponsible: values.nameResponsible,
            responsibleCellPhone: values.responsibleCellPhone,
          },
        };
        const { data } = await axios.put(`/users/${userTriggerData._id}`, user);
        console.log(data); // eslint-disable-line
        user.role = 'pharmacy';
        setEditedDataUser(user);
      } else {
        const { data } = await axios.put(
          `/users/${userTriggerData._id}`,
          values,
        );
        console.log(data); // eslint-disable-line
        values.role = 'adminOrSupplier';
        setEditedDataUser(values);
      }
      toggleModal(setShowEditUser, showEditUser);
    } catch (error) {
      setShowEditUser(false);
      if (
        error.response.data.status[0]?.message === 'email must be a valid email'
      ) {
        setErrorModalMsg({
          bol: true,
          msg: 'El email ingresado no es valido',
          modal: () => setShowEditUser(true),
        });
      } else if (error.response.data.message === 'Duplicate index') {
        setErrorModalMsg({
          bol: true,
          msg: 'El email que quiere asignar ya esta en uso',
          modal: () => setShowEditUser(true),
        });
      } else {
        setErrorModalMsg({
          bol: true,
          msg: 'Ocurrio un error inesperado recarge la página e intente de nuevo',
          modal: () => setShowEditUser(true),
        });
      }
      console.log(error); // eslint-disable-line
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo); // eslint-disable-line
  };

  return (
    <Modal
      title="Editar usuario"
      visible={showEditUser}
      footer={null}
      onCancel={() => toggleModal(setShowEditUser, showEditUser)}
      className={style.newUserModal}
    >
      <div>
        <Form
          form={form}
          layout="vertical"
          labelCol={{
            span: 13,
          }}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ 'margin-top': '.25rem' }}
        >
          <FormBuilder items={fields} />
          <Form.Item>
            <div>
              <CustomButton
                color="btnOutline"
                size="bg"
                htmlType="submit"
                content="EDITAR"
                className={style.addUserFooterBtn}
              />
            </div>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

// /admin User More Data Modal
const ModalUserData = (props) => {
  const { showUserData, setShowUserData, toggleModal, userTriggerData } = props;
  const [fields, setFields] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    if (userTriggerData?.role === 'pharmacy') {
      const fields = UserDataFields(userTriggerData);
      setFields(fields);
    } else {
      const fields = NoPhUserDataFields(userTriggerData);
      setFields(fields);
    }
  }, [userTriggerData]);

  return (
    <Modal
      title="Datos del usuario"
      visible={showUserData}
      footer={null}
      onCancel={() => toggleModal(setShowUserData, showUserData)}
      className={style.newUserModal}
    >
      <div>
        <Form
          form={form}
          layout="vertical"
          labelCol={{
            span: 12,
          }}
          name="basic"
          style={{ 'margin-top': '.25rem' }}
        >
          <FormBuilder items={fields} />
          <Form.Item>
            <div>
              <CustomButton
                color="btnOutline"
                size="bg"
                content="CERRAR"
                className={style.addUserFooterBtn}
                onclick={() => toggleModal(setShowUserData, showUserData)}
              />
            </div>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

// Reusable modal
const SmallModal = (props) => {
  const {
    title,
    className,
    firstBtn,
    secondBtn,
    toggle,
    set,
    state,
    howManyBtn,
    reOpenModal,
    zIndex,
    reload,
    content,
    destroyOnClose
  } = props;

  const btns = howManyBtn === '2';

  const onClose = () => {
    if (reload) {
      window.location.reload();
    } else {
      if (reOpenModal) {
        reOpenModal();
      }
      toggle(set, state);
    }
  };

  return (
    <Modal
      title={title}
      visible={state}
      footer={null}
      onCancel={() => onClose()}
      className={className}
      zIndex={zIndex}
      destroyOnClose={destroyOnClose}
    >
      {content && content}
      <div className={style.smallModalFooter}>
        {btns && <CustomButton {...firstBtn} className={style.smBtn} />}

        <CustomButton {...secondBtn} />
      </div>
    </Modal>
  );
};

// /admin Add Stand Modal
const AddStandModal = (props) => {
  const {
    toggleModal,
    setShowStandsModal,
    showStandsModal,
    hall,
    setHall,
    hallStands,
    handleShowModal,
    getUserStands,
    hallState
  } = props;

  useEffect(() => {
    getUserStands();
  }, [hall]);

  const {
    sectHeader,
    usersTableHeader,
    headerTitle,
    halls,
    standTitleH,
    hActive,
    notActive,
    activeTitle,
    addStandModal,
    hallContainer,
  } = style;

  const [standPage, setStandPage] = useState(1);

  const hallActive = (h3Hall, title) => {
    if (h3Hall === hall) {
      if (title) {
        return activeTitle;
      }
      return hActive;
    } else {
      if (title) {
        return '';
      }
      return notActive;
    }
  };

  return (
    <Modal
      title=""
      visible={showStandsModal}
      footer={null}
      onCancel={() => toggleModal(setShowStandsModal, showStandsModal)}
      className={addStandModal}
      style={{ top: 50 }}
    >
      <div>
        <div className={`${sectHeader} ${usersTableHeader}`}>
          <div className={`${headerTitle} ${standTitleH}`}>
            <h1>
              <b>Seleccionar stand</b>
            </h1>
            <div className={''}></div>
          </div>
          <div className={halls}>
            <div onClick={() => setHall('medicine')}>
              <h3 className={hallActive('medicine', true)}>
                Halls 1: Medicamento
              </h3>
              <span className={hallActive('medicine')}></span>
            </div>
            <div onClick={() => setHall('perfume')}>
              <h3 className={hallActive('perfume', true)}>
                Halls 2: Perfumeria
              </h3>
              <span className={hallActive('perfume')}></span>
            </div>
            <div onClick={() => setHall('cosmetic')}>
              <h3 className={hallActive('cosmetic', true)}>
                Halls 3: Dermo Cosmética
              </h3>
              <span className={hallActive('cosmetic')}></span>
            </div>
          </div>
        </div>
      </div>
      <div id="imgContainer" className={hallContainer}>
        <DisplayStands
          occupedStands={hallStands.length !== 0 ? hallStands.data : []}
          handleShowModal={handleShowModal}
          hall={hall}
          standPage={standPage}
          setStandPage={setStandPage}
          hallState={hallState}
        />
      </div>
    </Modal>
  );
};

const CustomSideModal = ({ setShowSideBar, showSideBar, sellData }) => {
  const {
    sideBarPos,
    sideBarContainer,
    sideBarHeader,
    sellReqOwner,
    reqDataContainer,
    light,
    close,
  } = style;
  const [closingBar, setClosingBar] = useState(false);
  let prLength = 0;

  useEffect(() => {
    if (showSideBar) {
      setClosingBar(false);
    }
  }, [showSideBar]);

  const handleClose = () => {
    setClosingBar(true);
    setTimeout(() => {
      setShowSideBar(false);
    }, 150);
  };

  return (
    <div className={sideBarContainer}>
      {showSideBar && (
        <div className={`${closingBar ? close : ''}`}>
          <div className={`${sideBarPos}`}>
            <div className={sideBarHeader}>
              <div className={sellReqOwner}>
              </div>
              <div>
                <CloseOutlined onClick={handleClose} />
              </div>
            </div>
            <div className={reqDataContainer}>
              {sellData.comboData?.description &&
                <div>
                  <h4>Descripción del combo</h4>
                  <h4 className={light}>{sellData.comboData?.description}</h4>
                </div>
              }
              {sellData.comboData?.paymentDeadline &&
                <div>
                  <h4>Deadline del pago</h4>
                  <h4 className={light}>{sellData.comboData?.paymentDeadline}</h4>
                </div>
              }
              {sellData.comboData?.totalItemsQuantity &&
                <div>
                  <h4>Total de items del combo</h4>
                  <h4 className={light}>{sellData.comboData?.totalItemsQuantity}</h4>
                </div>
              }
              {sellData.comboData?.closedCombo &&
                <div>
                  <h4>Tipo de combo</h4>
                  <h4 className={light}>{sellData.comboData?.closedCombo ? 'Cerrado' : 'Abierto'}</h4>
                </div>
              }
              {sellData.description &&
                <div>
                  <h4>Descripción</h4>
                  <h4 className={light}>{sellData?.description}</h4>
                </div>
              }
              {sellData.pharmacyUser?.accountNumber &&
                <div>
                  <h4>Número de cuenta</h4>
                  <h4 className={light}>{sellData.pharmacyUser?.accountNumber}</h4>
                </div>
              }
              {sellData.pharmacyUser?.pharmacy?.name &&
                <div>
                  <h4>Nombre Farmacia</h4>
                  <h4 className={light}>{sellData.pharmacyUser.pharmacy?.name}</h4>
                </div>
              }
              {sellData.pharmacyUser?.pharmacy?.owner &&
                <div>
                  <h4>Farmacia dueño</h4>
                  <h4 className={light}>
                    {sellData.pharmacyUser?.pharmacy?.owner}
                  </h4>
                </div>
              }
              {sellData.pharmacyUser?.pharmacy?.cellPhone &&
                <div>
                  <h4>Farmacia teléfono</h4>
                  <h4 className={light}>
                    {sellData.pharmacyUser?.pharmacy?.cellPhone}
                  </h4>
                </div>
              }
              {sellData.pharmacyUser?.pharmacy?.email &&
                <div>
                  <h4>Farmacia email</h4>
                  <h4 className={light}>
                    {sellData.pharmacyUser?.pharmacy?.email}
                  </h4>
                </div>
              }
              {sellData.pharmacyUser?.pharmacy?.nameResponsible &&
                <div>
                  <h4>Responsable de compras</h4>
                  <h4 className={light}>
                    {sellData.pharmacyUser?.pharmacy?.nameResponsible}
                  </h4>
                </div>
              }
              {sellData.pharmacyUser?.pharmacy?.responsibleCellPhone &&
                <div>
                  <h4>Responsable de compras teléfono</h4>
                  <h4 className={light}>
                    {sellData.pharmacyUser?.pharmacy?.responsibleCellPhone}
                  </h4>
                </div>
              }
              {sellData.standUser?.fullName &&
                <div>
                  <h4>Proveedor</h4>
                  <h4 className={light}>{sellData.standUser.fullName}</h4>
                </div>
              }
              {sellData.standUser?.email &&
                <div>
                  <h4>Proveedor email</h4>
                  <h4 className={light}>{sellData.standUser.email}</h4>
                </div>
              }
              {sellData.createdAt &&
                <div>
                  <h4>Fecha de la compra</h4>
                  <h4 className={light}>{moment(sellData.createdAt).format('DD-MM-YYYY HH:mm')}</h4>
                </div>
              }
              {sellData.products?.map((product) => {
                if (product.product !== null) {
                  prLength += 1;
                  return (
                    <>
                      <div>
                        <h3>Producto {prLength}</h3>
                      </div>
                      <div>
                        <h4>ID articulo</h4>
                        <h4 className={light}>{product.product.idArticle}</h4>
                      </div>
                      <div>
                        <h4>Cantidad del articulo</h4>
                        <h4 className={light}>{product.quantity}</h4>
                      </div>
                      <div>
                        <h4>Código de barra</h4>
                        <h4 className={light}>{product.product.barcode}</h4>
                      </div>
                      <div>
                        <h4>Código de articulo</h4>
                        <h4 className={light}>{product.product.codArticle}</h4>
                      </div>
                      <div>
                        <h4>Código de laboratorio</h4>
                        <h4 className={light}>{product.product.codLab}</h4>
                      </div>
                      <div>
                        <h4>Descripción</h4>
                        <h4 className={light}>{product.product.description}</h4>
                      </div>
                      <div>
                        <h4>Precio de farmacia</h4>
                        <h4 className={light}>
                          {product.product.pharmacyPrice}
                        </h4>
                      </div>
                      <div>
                        <h4>Precio publico</h4>
                        <h4 className={light}>{product.product.publicPrice}</h4>
                      </div>
                    </>
                  );
                }
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const CustomSideModalStands = ({ setShowSideBar, showSideBar, stand, setHallStands, hall }) => {
  const {
    sideBarPos,
    sideBarContainer,
    sideBarHeader,
    sellReqOwner,
    reqDataContainer,
    light,
    close,
  } = style;
  const [closingBar, setClosingBar] = useState(false);

  useEffect(() => {
    if (showSideBar) {
      setClosingBar(false);
    }
  }, [showSideBar]);

  const handleClose = () => {
    setClosingBar(true);
    setTimeout(() => {
      setShowSideBar(false);
    }, 150);
  };

  const handleDeleteStand = async () => {
    Modal.confirm({
      title: 'Está seguro que quiere borrar el stand?',
      icon: <ExclamationCircleOutlined />,
      content: 'Sólo pueden borrarse stands que no hayan generado ventas',
      okText: 'Borrar',
      okType: 'danger',
      cancelText: 'Cancelar',
      async onOk() {
        try {
          const opt = {
            perfume: 'perfumeria',
            cosmetic: 'dermocosmetica',
            medicine: 'medicamentos',
          };
          await axios.delete(`/stands/${stand._id}`);
          message.success('El stand ha sido borrado');
          const { data } = await axios.get(`/stands?section=${opt[hall]}`);
          setHallStands(data.data);
        } catch (error) {
          message.error(
            error.response.data.status === 'Stand with orders cannot be deleted'
              ? 'No se puede borrar un stand con compras'
              : 'No se ha podido borrar el stand',
          );
        }
      },
    });
  };

  const translateType = {
    intermediate: 'intermedio',
    standard: 'estandar',
    full: 'full',
  };

  const translateSect = (sect) => {
    if (sect !== 'medicine' && sect !== 'perfume' && sect !== 'cosmetic') {
      return sect;
    } else {
      const trsOpts = {
        medicine: 'medicamentos',
        perfume: 'perfumeria',
        cosmetic: 'dermocosmética',
      };
      return trsOpts[sect];
    }
  };

  const { user, createdAt, section, type } = stand;

  return (
    <div className={sideBarContainer}>
      {showSideBar && (
        <div className={`${closingBar ? close : ''}`}>
          <div className={`${sideBarPos}`}>
            <div className={sideBarHeader}>
              <div className={sellReqOwner}>
                <h3>{`#${stand.standNumber}`}</h3>
                <h2>{user ? user.fullName : 'Stand libre'}</h2>
              </div>
              <div>
                <CloseOutlined onClick={handleClose} />
              </div>
            </div>
            <div className={reqDataContainer}>
              <div>
                <h4>Nombre</h4>
                <h4 className={light}>{stand.name}</h4>
              </div>
              <div>
                <h4>Stand creado el</h4>
                <h4 className={light}>{createdAt}</h4>
              </div>
              <div>
                <h4>Teléfono del proveedor</h4>
                <h4 className={light}>{user ? user.phoneNumber : ''}</h4>
              </div>
              <div>
                <h4>Email del proveedor</h4>
                <h4 className={light}>{user ? user.email : ''}</h4>
              </div>
              <div>
                <h4>Tipo de stand</h4>
                <h4 className={light}>{translateType[type]}</h4>
              </div>
              <div>
                <h4>Hall</h4>
                <h4 className={light}>{translateSect(section)}</h4>
              </div>
              <div style={{justifyContent: 'end'}}>
                {stand._id && <DeleteOutlined
                  style={{color: '#F57255', fontSize: '1.5rem', marginTop:'1em', justifyContent: 'end'}}
                  onClick={handleDeleteStand}
                />} 
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const LastStepAssingStand = (props) => {
  const {
    toggleModal,
    userTriggerData,
    setShowStandsModalFS,
    showStandsModalFS,
    handleNewStand,
    standTriggeredData,
  } = props;

  const {
    standSampleContainer,
    typeStandSelect,
    hallH,
    standsType,
    standSampleImg,
    btnContainersST,
    selectIdItems,
    chipItem,
    labInput,
    labSelect,
    addLab,
    labSelectInput,
    chipRemove,
    chipValue,
    failLabsMessage,
    idItemsSelect,
  } = style;

  const [failTrigger, setFailTrigger] = useState(false);
  const [alreadySelTrigger, setAlreadySelTrigger] = useState(false);
  const [labs, setLabs] = useState([]);
  const [labsSelected, setLabsSelected] = useState([]);

  useEffect(() => {
    const getLabs = async () => {
      try {
        const { data } = await axios.get('/products/labs');
        setLabs(data.data);
      } catch (error) {
        console.log(error); // eslint-disable-line
      }
    };
    getLabs();
  }, []);

  const handleAddLab = () => {
    const input = document.getElementById('inputLabs');
    const labExist = labs.find((lab) => lab === parseInt(input.value));
    const labAlreadySel = labsSelected.find((lab) => lab === labExist);
    if (labExist && !labAlreadySel) {
      setLabsSelected([...labsSelected, labExist]);
      input.value = '';
    } else if (labExist) {
      setAlreadySelTrigger(true);
      setTimeout(() => {
        setAlreadySelTrigger(false);
      }, 3000);
    } else {
      setFailTrigger(true);
      setTimeout(() => {
        setFailTrigger(false);
      }, 3000);
    }
  };

  const handleChipRemove = (opt) => {
    const labsFiltered = labsSelected.filter((lab) => lab !== opt);
    setLabsSelected(labsFiltered);
  };

  const handleContinue = () => {
    const sectionOpt = {
      medicine: 'medicamentos',
      cosmetic: 'dermocosmetica',
      perfume: 'perfumeria',
    };
    const stand = {
      standNumber: standTriggeredData.standNumber,
      section: sectionOpt[standTriggeredData.section],
      type: standType,
      user: userTriggerData._id,
      labs: labsSelected,
    };
    handleNewStand(stand, setLabsSelected, setStandType);
  };

  const [standType, setStandType] = useState('full');

  const getHall = (hall) => {
    const hallNameTranslated = {
      medicine: 'Medicamentos',
      cosmetic: 'Dermocosmética',
      perfume: 'Perfumeria',
    };
    return hallNameTranslated[hall];
  };

  return (
    <Modal
      visible={showStandsModalFS}
      footer={null}
      onCancel={() => toggleModal(setShowStandsModalFS, showStandsModalFS)}
      bodyStyle={{ borderRadius: '2rem' }}
    >
      <div className={standSampleContainer}>
        {standType === 'full' && (
          <Image preview={false} src={standFull} alt="" className={standSampleImg} />
        )}
        {standType === 'intermediate' && (
          <Image preview={false} src={standMedium} alt="" className={standSampleImg} />
        )}
        {standType === 'standard' && (
          <Image preview={false} src={standSmall} alt="" className={standSampleImg} />
        )}
      </div>
      <div className={hallH}>
        <h3>
          <b>
            Hall: {getHall(standTriggeredData.section)} stand{' '}
            {standTriggeredData.standNumber}
          </b>
        </h3>
      </div>
      <div className={typeStandSelect}>
        <h5>TIPO DE STAND</h5>
        <div className={standsType}>
          <div onClick={() => setStandType('standard')}>
            <Image preview={false} src={standSmall} alt="" />
            <h4 style={{textAlign: 'center'}}><b><i>Basico</i></b></h4>
          </div>
          <div onClick={() => setStandType('intermediate')}>
            <Image preview={false} src={standMedium} alt="" />
            <h4 style={{textAlign: 'center'}}><b><i>Medium</i></b></h4>
          </div>
          <div onClick={() => setStandType('full')}>
            <Image preview={false} src={standFull} alt="" />
            <h4 style={{textAlign: 'center'}}><b><i>Premium</i></b></h4>
          </div>
        </div>
      </div>
      <div className={selectIdItems}>
        <h4>ID ITEMS</h4>
        <div className={idItemsSelect}>
          <div className={labSelect}>
            <div className={labSelectInput}>
              <input
                id="inputLabs"
                placeholder="Buscar labs"
                type="text"
                className={labInput}
              />
              <div className={addLab}>
                <div onClick={() => handleAddLab()}>
                  <PlusOutlined />
                </div>
              </div>
            </div>
            {labsSelected.length !== 0
              ? labsSelected.map((opt, i) => (
                <div key={i} className={chipItem}>
                  <div className={chipValue}>{opt}</div>
                  <div
                    className={chipRemove}
                    onClick={() => handleChipRemove(opt)}
                  >
                    <MinusOutlined />
                  </div>
                </div>
              ))
              : ''}
          </div>
          {failTrigger ? (
            <div className={failLabsMessage}>
              No se encontro ese código de laboratorio
            </div>
          ) : (
            ''
          )}
          {alreadySelTrigger ? (
            <div className={failLabsMessage}>
              El código ya esta seleccionado
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
      <div className={btnContainersST}>
        <CustomButton
          size="bg"
          color="btnOrange"
          content="Cancelar"
          onclick={() => toggleModal(setShowStandsModalFS, showStandsModalFS)}
        />
        <CustomButton
          size="bg"
          color="btnOutline"
          content="Continuar"
          onclick={() => handleContinue()}
        />
      </div>
    </Modal>
  );
};

// NEW CONFERENCE
const ConferenceNewModal = (props) => {
  const {
    toggleModal,
    newConferenceModal,
    setNewConferenceModal,
    newConference
  } = props;
  const {
    formContainerConferences,
    itemsContainer,
    uploadImgContainer,
    uploadImgBtn,
    footerConferencesNew,
    speakerUploadAgain,
    speakerImgContainer,
    speakerImage
  } = style;

  const [form] = Form.useForm();
  const [speakerImg, setSpeakerImg] = useState('');
  const [failImgUp, setFailImgUp] = useState(false);

  useEffect(() => {
    if (speakerImg !== '') {
      const speakerImgContainer = document.getElementById('speakerImg');
      speakerImgContainer.style.backgroundImage = `url(${speakerImg})`;
    }
  }, [speakerImg]);

  useEffect(() => {
    if (failImgUp) {
      const failUploadText = document.getElementById('failUpload');
      failUploadText.style.color = 'rgb(255, 109, 109)';
    } else {
      const failUploadText = document.getElementById('failUpload');
      failUploadText.style.color = 'rgba(255, 109, 109, 0)';
    }
  }, [failImgUp]);

  const onFinish = async (values) => {
    if (speakerImg !== '') {
      setNewConferenceModal(false);
      setFailImgUp(false);
      newConference(values, speakerImg);
    } else {
      setFailImgUp(true);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo); // eslint-disable-line
  };

  const hiddenFileInput = useRef(null);

  const virtualClick = () => {
    hiddenFileInput.current.click();
  };

  const handleUploadImg = async (e) => {
    const fileUploaded = e.target.files[0];
    const fileValidations = beforeUpload(fileUploaded);
    if (fileValidations) {
      setFailImgUp(true);
    } else {
      const base64 = await getBase64(fileUploaded);
      setSpeakerImg(base64);
      setFailImgUp(false);
    }
  };

  function getBase64(img) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener('load', () => resolve(reader.result));
      reader.readAsDataURL(img);
    });
  }

  const onInputClick = (event) => {
    event.target.value = '';
  };

  function beforeUpload(file) {
    const sizeVal = file.size <= 1572864;
    const typeVal = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
    if (!sizeVal || !typeVal) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <Modal
      title="Crear conferencia"
      visible={newConferenceModal}
      footer={null}
      onCancel={() => toggleModal(setNewConferenceModal, newConferenceModal)}
      className=""
      width="750px"
    >
      <div>
        <Form
          form={form}
          layout="vertical"
          labelCol={{
            span: 15,
          }}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ 'margin-top': '.25rem' }}
        >
          <div className={formContainerConferences}>
            <div className={itemsContainer}>
              <Form.Item
                label="Nombre de la conferencia"
                name="name"
                rules={[
                  {
                    required: true,
                    message: 'Por favor ingrese el nombre',
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Descripción"
                name="description"
                rules={[
                  {
                    required: true,
                    message: 'Por favor ingrese descripción',
                  },
                ]}
              >
                <Input.TextArea />
              </Form.Item>
              <Form.Item
                label="URL de youtube"
                name="youtubeLink"
                rules={[
                  {
                    required: true,
                    message: 'Por favor ingrese el link',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </div>
            <div className={itemsContainer}>
              <div className={uploadImgContainer}>
                <input
                  type="file"
                  style={{ display: 'none' }}
                  onChange={handleUploadImg}
                  onClick={onInputClick}
                  ref={hiddenFileInput}
                />
                <button
                  type="button"
                  className={uploadImgBtn}
                  onClick={virtualClick}
                >
                  {speakerImg !== '' ? (
                    <div className={speakerImgContainer}>
                      <div id="speakerImg" className={speakerImage}></div>
                      <div className={speakerUploadAgain}>
                        <UploadOutlined />
                      </div>
                    </div>
                  ) : (
                    <UploadOutlined />
                  )}
                </button>
                <div id='failUpload' style={{'color': 'rgba(0, 0, 0, 0)', 'fontSize': '0.8rem'}}>Por favor seleccione una imagen jpg o png de 150x150 como maxima resolución y maximo 1,5mb</div>
              </div>
              <Form.Item
                label="Nombre del disertante"
                name="speakers"
                rules={[
                  {
                    required: true,
                    message: 'Por favor ingrese el nombre del disertante',
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Fecha de la conferencia"
                name="date"
              >
                <DatePicker showTime={{ format: 'HH:mm' }} locale={locale}/>
              </Form.Item>
            </div>
          </div>
          <div className={style.smallModalFooter}>
            <div className={footerConferencesNew}>
              <CustomButton
                content="CANCELAR"
                size="sm"
                color="btnOutline"
                onclick={() =>
                  toggleModal(setNewConferenceModal, newConferenceModal)
                }
              />
              <CustomButton
                content="CREAR"
                size="sm"
                color="btnOrange"
                htmlType="submit"
              />
            </div>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

// CONFERENCE DATA
const ConferenceDataModal = (props) => {
  const { toggleModal, showMoreData, setShowMoreData, conferenceData, deleteFromDataModal, openEdit, zIndex } = props;

  const {
    modalContentConferenceData,
    iframe,
    conferenceDataContainer,
    conferenceTextData,
    closeModalBtn,
    speakerData,
    speakerImg,
    conferenceDate,
    confDescription
  } = style;

  useEffect(() => {
    if (conferenceData.image !== '') {
      const speakerImgContainer = document.getElementById('speakerImg');
      speakerImgContainer.style.backgroundImage = `url(${conferenceData.image})`;
    }
  }, [conferenceData]);

  return (
    <Modal
      title=""
      visible={showMoreData}
      footer={null}
      onCancel={() => toggleModal(setShowMoreData, showMoreData)}
      className=""
      width="750px"
      style={{ top: '45px' }}
      zIndex={zIndex}
    >
      <div className={modalContentConferenceData}>
        <div className={iframe}>
          <iframe
            width="560"
            height="315"
            src={conferenceData.youtubeLink}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
          <div>
            <LoadingOutlined />
          </div>
        </div>
        <div className={conferenceDataContainer}>
          <div className={conferenceTextData}>
            <div>
              <h2>{conferenceData.name}</h2>
            </div>
            <div className={confDescription}>&emsp;{conferenceData.description}</div>
            <div className={conferenceDate}>
              <div><b>FECHA:</b> {conferenceData.date ? moment(conferenceData.date).format('DD-MM-YYYY HH:mm') : ''}</div>
            </div>
            <div className={closeModalBtn}>
              <CustomButton
                content="EDITAR"
                size="sm"
                color="btnOrange"
                onclick={() => openEdit(conferenceData)}
              >
                <FormOutlined />
              </ CustomButton>
              <CustomButton
                content="ELIMINAR"
                size="sm"
                color="btnOutline"
                onclick={() => deleteFromDataModal(conferenceData)}
              >
                <DeleteOutlined />
              </ CustomButton>
            </div>
          </div>
          <div className={speakerData}>
            <div id='speakerImg' className={speakerImg}></div>
            <div>{conferenceData.speakers}</div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

// EDIT CONFERENCE
const EditConferenceModal = (props) => {
  const {
    toggleModal,
    editingConference,
    setEditConferenceModal,
    editConferenceModal,
    editConference,
    zIndex
  } = props;
  const {
    formContainerConferences,
    itemsContainer,
    uploadImgContainer,
    uploadImgBtn,
    footerConferencesNew,
    speakerUploadAgain,
    speakerImgContainer,
    speakerImage
  } = style;

  const [form] = Form.useForm();
  const [speakerImg, setSpeakerImg] = useState('');
  const [failImgUp, setFailImgUp] = useState(false);

  useEffect(() => {
    if (speakerImg === '') {
      setSpeakerImg(editingConference.image);
    } else {
      const speakerImgContainer = document.getElementById('speakerImg');
      speakerImgContainer.style.backgroundImage = `url(${speakerImg})`;
    }
  }, [speakerImg]);

  useEffect(() => {
    if (failImgUp) {
      const failUploadText = document.getElementById('failUpload');
      failUploadText.style.color = 'rgb(255, 109, 109)';
    } else {
      const failUploadText = document.getElementById('failUpload');
      failUploadText.style.color = 'rgba(255, 109, 109, 0)';
    }
  }, [failImgUp]);

  const onFinish = async (values) => {
    if (speakerImg !== '') {
      setEditConferenceModal(false);
      setFailImgUp(false);
      editConference(values, editingConference._id, speakerImg);
    } else {
      setFailImgUp(true);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo); // eslint-disable-line
  };

  const hiddenFileInput = useRef(null);

  const virtualClick = () => {
    hiddenFileInput.current.click();
  };

  const handleUploadImg = async (e) => {
    const fileUploaded = e.target.files[0];
    const fileValidations = beforeUpload(fileUploaded);
    if (fileValidations) {
      setFailImgUp(true);
    } else {
      const base64 = await getBase64(fileUploaded);
      setSpeakerImg(base64);
      setFailImgUp(false);
    }
  };

  function getBase64(img) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener('load', () => resolve(reader.result));
      reader.readAsDataURL(img);
    });
  }

  const onInputClick = (event) => {
    event.target.value = '';
  };

  function beforeUpload(file) {
    const sizeVal = file.size <= 1572864;
    const typeVal = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
    if (!sizeVal || !typeVal) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <Modal
      title="Editar conferencia"
      visible={editConferenceModal}
      footer={null}
      onCancel={() => toggleModal(setEditConferenceModal, editConferenceModal)}
      className=""
      width="750px"
      zIndex={zIndex}
    >
      <div>
        <Form
          form={form}
          layout="vertical"
          labelCol={{
            span: 15,
          }}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ 'margin-top': '.25rem' }}
        >
          <div className={formContainerConferences}>
            <div className={itemsContainer}>
              <Form.Item
                label="Nombre de la conferencia"
                name="name"
                initialValue={editingConference.name}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Descripción"
                name="description"
                initialValue={editingConference.description}
              >
                <Input.TextArea />
              </Form.Item>
              <Form.Item
                label="URL de youtube"
                name="youtubeLink"
                initialValue={editingConference.youtubeLink}
              >
                <Input />
              </Form.Item>
            </div>
            <div className={itemsContainer}>
              <div className={uploadImgContainer}>
                <input
                  type="file"
                  style={{ display: 'none' }}
                  onChange={handleUploadImg}
                  onClick={onInputClick}
                  ref={hiddenFileInput}
                />
                <button
                  type="button"
                  className={uploadImgBtn}
                  onClick={virtualClick}
                >
                  {speakerImg !== '' ? (
                    <div className={speakerImgContainer}>
                      <div id="speakerImg" className={speakerImage}></div>
                      <div className={speakerUploadAgain}>
                        <UploadOutlined />
                      </div>
                    </div>
                  ) : (
                    <UploadOutlined />
                  )}
                </button>
                <div id='failUpload' style={{'color': 'rgba(0, 0, 0, 0)', 'fontSize': '0.8rem'}}>Por favor seleccione una imagen jpg o png de 150x150 como maxima resolución y maximo 1,2mb</div>
              </div>
              <Form.Item
                label="Nombre del disertante"
                name="speakers"
                initialValue={editingConference.speakers}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Fecha de la conferencia"
                name="date"
              >
                <DatePicker showTime={{ format: 'HH:mm' }} format={'DD-MM-YYYY HH:mm'} locale={locale} defaultValue={editingConference.date ? moment(editingConference.date) : '' }/>
              </Form.Item>
            </div>
          </div>
          <div className={style.smallModalFooter}>
            <div className={footerConferencesNew}>
              <CustomButton
                content="CANCELAR"
                size="sm"
                color="btnOrange"
                onclick={() =>
                  toggleModal(setEditConferenceModal, editConferenceModal)
                }
              />
              <CustomButton
                content="EDITAR"
                size="sm"
                color="btnOutline"
                htmlType="submit"
              />
            </div>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export {
  ModalAddUser,
  SmallModal,
  ModalEditUser,
  ModalUserData,
  AddStandModal,
  CustomSideModal,
  CustomSideModalStands,
  LastStepAssingStand,
  ConferenceDataModal,
  ConferenceNewModal,
  EditConferenceModal,
};
